
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import Board from '~/components/Common/Board'

export default {
    name: 'MobileStockPaper',
    components: { Board },
    computed : {
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
    },
}
